module.exports = __webpack_public_path__ + "static/media/document-outline.08d7afe5.svg";